import { cva } from '@/styled-system/css';

export const calendarDayRecipe = cva({
  base: {
    display: 'grid',
    placeItems: 'center',
    position: 'relative',
    width: 'Calendar.Day.width',
    height: 'Calendar.Day.height',
    transition: {
      _motionReduce: 'none',
      _motionSafe: 'background-color 200ms ease, box-shadow 200ms ease, border-color 200ms ease',
    },
    focusOutline: true,
    zIndex: {
      base: 1,
      _focusVisible: 2,
    },
    backgroundColor: {
      base: 'Calendar.Day.bg.default',
    },
    borderColor: {
      base: 'Calendar.Day.border.default',
    },
    color: {
      base: 'Calendar.Day.label.default',
    },
    borderStyle: 'solid',
    textStyle: 'body-sm-bold',
    borderRadius: 'Calendar.Day',
  },
  variants: {
    selected: {
      true: {
        borderWidth: 'Calendar.Day.selected',
      },
      false: {
        borderWidth: 'Calendar.Day.default',
      },
    },
    today: {
      true: {},
      false: {},
    },
    disabled: {
      true: {
        cursor: 'default',
        opacity: 'disabled',
        textDecoration: 'line-through',
      },
      false: {
        cursor: 'pointer',
        backgroundColor: {
          _hover: 'Calendar.Day.bg.hover',
          _active: 'Calendar.Day.bg.pressed',
        },
        color: {
          _hover: 'Calendar.Day.label.hover',
          _active: 'Calendar.Day.label.pressed',
        },
        borderColor: {
          _hover: 'Calendar.Day.border.hover',
          _active: 'Calendar.Day.border.pressed',
        },
      },
    },
  },
  compoundVariants: [
    {
      selected: false,
      disabled: false,
      css: {
        backgroundColor: {
          _hover: 'Calendar.Day.bg.hover',
          _active: 'Calendar.Day.bg.pressed',
        },
        borderColor: {
          _hover: 'Calendar.Day.border.hover',
          _active: 'Calendar.Day.border.pressed',
        },
        color: {
          _hover: 'Calendar.Day.label.hover',
          _active: 'Calendar.Day.label.pressed',
        },
      },
    },
    {
      today: [true, false],
      selected: true,
      disabled: false,
      css: {
        borderColor: {
          base: 'Calendar.Day.border.selected',
          _hover: 'Calendar.Day.border.selectedHover',
          _active: 'Calendar.Day.border.selectedPressed',
        },
        backgroundColor: {
          base: 'Calendar.Day.bg.selected',
          _hover: 'Calendar.Day.bg.selectedHover',
          _active: 'Calendar.Day.bg.selectedPressed',
        },
        color: {
          base: 'Calendar.Day.label.selected',
          _hover: 'Calendar.Day.label.selectedHover',
          _active: 'Calendar.Day.label.selectedPressed',
        },
      },
    },
    {
      today: true,
      selected: false,
      disabled: false,
      css: {
        borderColor: {
          base: 'Calendar.Day.border.today.default',
          _hover: 'Calendar.Day.border.today.hover',
          _active: 'Calendar.Day.border.today.pressed',
        },
        color: {
          base: 'Calendar.Day.label.default',
          _hover: 'Calendar.Day.label.hover',
          _active: 'Calendar.Day.label.pressed',
        },
      },
    },
  ],
});
